import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const TITLE_SALES_EXEC = '11554bb8-b73d-4696-9bc4-bd95407713cd';
export const SALES_MANAGER = 'af67e87d-5cbf-49c9-bbc9-d38a750743ed';
export const COUNTY_MANAGER = '3b4fdf13-2987-40b0-8c0b-07409164ffc0';

class LuOrganizationReportingRoleAppResource extends AppResource {

    /**
    * @returns {string}
    */
    appResourceType() {
        return 'lu-organization-reporting-role';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/organization/reporting/roles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'uuid',
            'slug',
            'title',
            'description',
        ];
    }
}

export default LuOrganizationReportingRoleAppResource;
